import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../generic/crud";
import {ENTITY_ID_DESIGNATION} from "../generic/Constants";
import {defaultDesignation} from "../generic/InitialStates";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AGCText} from "../../generic-components/AGCText";


export function DesignationAddEditDialog(props) {
    const {show, handleClose, id, onSave} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState(defaultDesignation);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Designation");
    const entityName = "Designation";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(designation, {resetForm}) {
            setIsLoading(true);
            if (!id) {
                apiGenericCreate(ENTITY_ID_DESIGNATION, designation).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_DESIGNATION, designation, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(false);

            genericGetOne(ENTITY_ID_DESIGNATION, id).then(
                ({data}) => {
                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultDesignation);
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            size="sm"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-12">
                                <AGCText formik={formik}
                                         name={"Designation Name"}
                                         placeHolder={'Enter Designation Name'}
                                         id={"name"}
                                         toolTip={"Please enter the Designation Name"}
                                         value={formik.values.name}/>
                            </Form.Group>
                        </div>

                        <br/>
                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
